function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgViewi = function SvgViewi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 25 25",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M2.65 11.876a.7.7 0 0 0 0 .702c1.87 3.228 5.36 5.4 9.356 5.4s7.487-2.173 9.356-5.4a.7.7 0 0 0 0-.702c-1.87-3.228-5.36-5.4-9.356-5.4s-7.487 2.173-9.356 5.4m17.287.35a9.4 9.4 0 0 0-15.86 0 9.4 9.4 0 0 0 15.86 0m-7.93-3.788c-2.09 0-3.788 1.697-3.788 3.788a3.79 3.79 0 0 0 7.578 0 3.79 3.79 0 0 0-3.79-3.788m0 1.4c1.318 0 2.39 1.07 2.39 2.388a2.39 2.39 0 0 1-4.778 0 2.39 2.39 0 0 1 2.388-2.388"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgViewi);
export default ForwardRef;